import { useState, useEffect } from 'react';
import { Container, Col, Row, ProgressBar, Form, Alert } from 'react-bootstrap';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useCookies } from 'react-cookie';
import axiosInterceptor from '../../services/axiosInterceptor';
import SurveyTableSection from '../../Components/SurveyTableSection/SurveyTableSection';
import ResultCard from './resultCard';
import { language } from '../../language';
import { useHistory } from 'react-router-dom';

function SurveyPage() {
    const [requiredSurvey, setRequiredSurvey] = useState([]);
    const [optionalSurvey, setOptionalSurvey] = useState([]);
    const [finishedINCASsurvey, setFinishedINCASsurvey] = useState([]);
    const [show, setShow] = useState(true);
    const history = useHistory();
    const [authCookie, setAuthCookie] = useCookies(['email_collected']);

    const intl = useIntl();
    const messages = defineMessages({
        remaining: {
            id: 'Home.remaining',
            defaultMessage: 'Remaining'
        },
        finishAll: {
            id: 'Home.finishAll',
            defaultMessage: 'You have finished all Surveys!'
        },
        finishOptional: {
            id: 'Home.finishOptional',
            defaultMessage: 'Finish the Optional Surveys for extra reward!'
        },
        requiredSurveys: {
            id: 'Home.requiredSurveys',
            defaultMessage: 'Required Surveys'
        },
        requiredSurveysInstruction: {
            id: 'Home.requiredSurveysInstruction',
            defaultMessage:
                'You must complete the following surveys to get the reward.'
        },
        optionalSurveys: {
            id: 'Home.optionalSurveys',
            defaultMessage: 'Optional Surveys'
        },
        optionalSurveysInstruction: {
            id: 'Home.optionalSurveysInstruction',
            defaultMessage: 'Complete the optional surveys to extra bonus'
        },
        completedSurveys: {
            id: 'Home.completedSurveys',
            defaultMessage: 'Completed Surveys'
        },
        completedSurveysInstruction: {
            id: 'Home.completedSurveysInstruction',
            defaultMessage: 'Surveys you completed'
        }
    });

    const fetchDataIncas = async () => {
        try {
            console.log("fetchDataIncas language:"+language)
            const response = await axiosInterceptor().get(
                'incas/all-survey' + '?lang=' + language
            );
            setRequiredSurvey(response.data.required);
            setOptionalSurvey(response.data.optional);
            setFinishedINCASsurvey(response.data.completed);
            // console.log("setFinishedINCASsurvey:"+JSON.stringify(response.data))
            // console.log("setFinishedINCASsurvey completed:"+JSON.stringify(response.data.completed))
        } catch (e) {
            console.log(e);
        }
    };

    const checkConsent = async () => {
        try {
            const response = await axiosInterceptor().get(
                'incas/consentAccepted'
            );
            if (!response.data.consentAccepted) {
                history.push('/consent');
            }
        } catch (e) {
            console.log(e);
            history.push('/consent');
        }
    };

    useEffect(() => {
        checkConsent();
        fetchDataIncas();
    }, []);

    return (
        <>
            <Container fluid>
                {authCookie?.email_collected != 'true' && show && (
                    <Row>
                        <Col xs={12} md={{ span: 10, offset: 1 }}>
                            <Alert
                                variant="info"
                                className="w-100 text-center"
                                onClose={() => setShow(false)}
                                dismissible
                            >
                                <FormattedMessage
                                    id="New1.addEmailAlert"
                                    defaultMessage="Add your email (above) if you want to leave the site and finish the survey later"
                                />
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col className="h2 mt-3">
                        <FormattedMessage
                            id="Home.welcome"
                            defaultMessage="Welcome to our Research Survey!"
                        />
                    </Col>
                </Row>

                <Row className="mt-3 mb-4">
                    <Col md={{ span: 6, offset: 3 }} xs={12}>
                        <ProgressBar
                            striped
                            now={((finishedINCASsurvey.length * 1.0) / 5) * 100}
                            label={`${
                                requiredSurvey.length + optionalSurvey.length
                            } ${intl.formatMessage(messages.remaining)}`}
                        />
                    </Col>
                </Row>
                {finishedINCASsurvey.length === 6 && (
                    <ResultCard
                        title={intl.formatMessage(messages.finishAll)}
                    />
                )}
                {requiredSurvey.length === 0 && optionalSurvey.length !== 0 && (
                    <ResultCard
                        title={intl.formatMessage(messages.finishOptional)}
                    />
                )}

                {requiredSurvey.length > 0 ? (
                    <>
                        <Row className="my-3">
                            <Col xs={12}>
                                <SurveyTableSection
                                    title={intl.formatMessage(
                                        messages.requiredSurveys
                                    )}
                                    surveys={requiredSurvey}
                                    instruction={intl.formatMessage(
                                        messages.requiredSurveysInstruction
                                    )}
                                    completed={false}
                                />
                            </Col>
                        </Row>
                    </>
                ) : (
                    <>
                        <Row className="my-3">
                            <Col xs={12}>
                                <SurveyTableSection
                                    title={intl.formatMessage(
                                        messages.optionalSurveys
                                    )}
                                    surveys={optionalSurvey}
                                    instruction={intl.formatMessage(
                                        messages.optionalSurveysInstruction
                                    )}
                                    completed={false}
                                />
                            </Col>
                        </Row>
                    </>
                )}

                <Row>
                    <Col xs={12}>
                        <SurveyTableSection
                            title={intl.formatMessage(
                                messages.completedSurveys
                            )}
                            surveys={finishedINCASsurvey}
                            instruction={intl.formatMessage(
                                messages.completedSurveysInstruction
                            )}
                            completed={true}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default SurveyPage;
